import { MutationTree } from 'vuex'
import { SynergridConnectionState } from './types'
import { idGenerator } from '@/services'

export const mutations: MutationTree<SynergridConnectionState> = {
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
  }
}
